export const types = {
  OPEN_DRAWER: 'common/drawers/nestingDefaultsDrawer/OPEN_DRAWER',
  CLOSE_DRAWER: 'common/drawers/nestingDefaultsDrawer/CLOSE_DRAWER',
};

export const drawer = {
  open: (payload: { isLinearNest: boolean }) => {
    return {
      type: types.OPEN_DRAWER,
      payload,
    };
  },
  close: () => ({
    type: types.CLOSE_DRAWER,
  }),
};
